<template>
    <v-form ref="postUploadForm" v-model="postValid" lazy-validation>
        <v-stepper v-model="activeStepper" class="transparent elevation-0">
            <v-stepper-items>
                <v-stepper-content step="1" class="px-0">
                    <!-- Post title -->
                    <div class="mt-2">
                        <v-text-field ref="postTitle" label="Title" color="grey" v-model="postTitle" :rules="[genericRules.requiredRule]" required @blur="resetField($refs.postTitle)" outlined background-color="primary" hide-details="auto" tile dense></v-text-field>
                    </div>
                    <!-- Photo uploader -->
                    <div class="mt-5">
                        <widget-media-uploader :photos="photos" @filesAdded="managePhotos" @deletePhoto="deletePhoto" @updatePhoto="updatePhoto" />
                    </div>
                </v-stepper-content>
                <v-stepper-content step="2" class="px-0">
                    <!-- Post description -->
                    <div class="mt-2">
                        <!-- <v-textarea ref="postDescription" label="Description" color="grey" v-model="postDescription" outlined background-color="primary" tile></v-textarea> -->
                        <wysiwig-editor ref="postDescription" v-model="postDescription" placeholder="Add description"></wysiwig-editor>
                    </div>
                    <!-- User tags -->
                    <!-- <div class="mt-5">
                        <v-autocomplete id="user-tag" v-model="tags" :items="users" filled chips background-color="primary" color="grey" label="Tag Peoples" item-text="name" item-value="name" outlined multiple clearable clear-icon="mdi-refresh" hide-selected hide-details>
                            <template v-slot:selection="data">
                                <v-chip color="grey darken-3" text-color="white" v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="removeTag(data.item)">
                                    <v-avatar left color="green">
                                        <span>{{ data.item.name[0] }}</span>
                                    </v-avatar>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data" color="grey">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                                <template v-else>
                                    <v-list-item-avatar>
                                        <v-avatar color="green">
                                            <span>{{ data.item.name[0] }}</span>
                                        </v-avatar>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                    </v-list-item-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </div> -->
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
        <v-bottom-navigation app fixed v-model="activeBarBtn" :input-value="bottomBar" v-if="showBottomBar" ref="bottomBar">
            <v-btn :disabled="activeStepper === 1" @click="prev">
                <span class="textLinks--text">
                    <v-icon large>mdi-chevron-left</v-icon> Prev
                </span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="sendPost" class="submit-button">
                <span class="textLinks--text">Post <v-icon large>mdi-send</v-icon></span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="activeStepper === 2" @click="next">
                <span class="textLinks--text">Next <v-icon large>mdi-chevron-right</v-icon></span>
            </v-btn>
        </v-bottom-navigation>
    </v-form>
</template>
<style scoped>
.v-btn.v-btn--disabled:not(.submit-button) {
    opacity: 0;
}
</style>
<script>
import formMixins from "@/mixins/mixin-forms"
import postCreateMixins from "@/mixins/mixin-post-create"
import wysiwigEditor from "@/components/editor/wysiwyg-editor.vue"
export default {
    mixins: [formMixins, postCreateMixins],
    components:{
        wysiwigEditor
    },
    props: ['users', 'photos', 'bottomBar', 'showBottomBar', 'loading'],
    data: () => ({
        activeBarBtn: 1,
        activeStepper: 1
    }),

    methods: {
        // Got to second step
        next() {
            if (this.$refs.postUploadForm.validate()) {
                this.activeStepper = 2
            }
        },

        // Got to first step
        prev() {
            this.activeStepper = 1
        }
    }
}
</script>